<div class="custom-mode-container">
  <p class="mode-name">
    <fa-duotone-icon *ngIf="currentModeConfig?.icon" [icon]="currentModeConfig?.icon"></fa-duotone-icon>
    <span>{{ currentModeConfig?.name }}</span>
  </p>
  <div class="exit-button button-stroked" (click)="exitMode()">Exit mode</div>
</div>
